<template>
    <!-- <header>
        <span class="btn" @click="router.back()"><van-icon name="arrow-left" size="20" /></span>
        <div class="input">
            <input type="text" v-model="searchValue" @change="changeTab(currentTab)" placeholder="请输入文章关键词搜索您需要的内容" />
            <img src="@/assets/imgs/icon16.png" />
        </div>
    </header> -->
    <div class="tabbar">
        <span :class="{ active: currentTab == 3 }" @click="changeTab(3)">鉴赏要闻</span>
        <span :class="{ active: currentTab == 1 }" @click="changeTab(1)">文物专题</span>
        <span :class="{ active: currentTab == 2 }" @click="changeTab(2)">人物专题</span>
        <span :class="{ active: currentTab == 4 }" @click="changeTab(4)">资讯杂谈</span>
    </div>

    <div class="news">
        <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" :offset="100" @load="fetchList">
            <div class="news_item" v-for="item in newsList" @click="router.push('/art-detail?id='+item.id)">
                <img :src="item.picUrl" class="banner_img">
                <div class="content">
                    <h5>{{ item.title }}</h5>
                    <div class="icons">
                        <span style="color: #9D9DA0;">作者: {{ item.author }}</span>
                        <span>
                            <img src="@/assets/imgs/icon5.png" alt=""> {{ item.browseCount }}
                            <img src="@/assets/imgs/icon6.png" alt="" style="margin-left: 15rem;"> {{ item.thumbsUpCount }}
                        </span>
                    </div>
                </div>
            </div>
        </van-list>
    </div>
</template>
<script setup>
import { onMounted, ref } from 'vue';
import { http } from '@/request/http'
import { useRoute, useRouter } from 'vue-router'
import { showNotify } from 'vant';
import { richTextToPlainText } from '@/utils/util'
const route = useRoute(), router = useRouter()
const currentTab = ref(1)
function changeTab(index) {
    finished.value = false
    currentTab.value = index
    newsList.value = []
    pageNo.value = 1
    fetchList()
}
const pageNo = ref(1)
const pageSize = 10
const finished = ref(false)
const loading = ref(false)
const newsList = ref([])
const searchValue = ref('')
function fetchList() {
    loading.value = true
    http.get(`/app-api/promotion/article/page?categoryId=${currentTab.value}&pageNo=${pageNo.value}&pageSize=${pageSize}&sortType=1&total=100`).then(res => {
        console.log(res);
        pageNo.value++
        loading.value = false
        newsList.value.push(...res.list)
        finished.value = newsList.value.length >= res.total
    }).catch(err => {
        finished.value = true
        showNotify('服务器错误，请稍后重试')
    })

}

onMounted(() => {
    currentTab.value = route.query.type
    fetchList()
})
</script>

<style scoped lang="scss">
header {
    display: flex;
    align-items: center;
    height: 60rem;
    justify-content: space-between;
    padding: 0 20rem;

    .btn {
        width: 40rem;
        height: 40rem;
        display: block;
        text-align: center;
        line-height: 40rem;
    }

    .input {
        width: 80%;
        display: flex;
        align-items: center;

        input {
            width: 100%;
            font-size: 12rem;
        }

        input::placeholder {
            color: #D8D8D8;
        }

        img {
            width: 30rem;
            height: 30rem;
        }
    }
}

.tabbar {
    display: flex;
    border-bottom: 1px solid #F0F0F0;
    margin: 0 20rem;

    span {
        display: block;
        width: 25%;
        text-align: center;
        line-height: 40rem;
        height: 40rem;
        color: #9D9D9D;
    }

    .active {
        color: #000;
        border-bottom: 1px solid #000;
    }
}

.news {
    padding-top: 20rem;

    .news_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10rem 20rem;
        width: 100%;
        img {
            width: 122rem;
            height: 92rem;
            object-fit: cover;
            flex-shrink: 0;
            margin-right: 20rem;
        }

        .content {
            width: calc(100% - 122rem - 20rem);
            h5 {
                font-size: 14rem;
                color: #333;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                width: 50%;
            }

            .icons {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 50rem;
                font-size: 12rem;
                width: 100%;
                img {
                    width: 20rem;
                    height: 20rem;
                    margin-right: 5rem;
                    margin-left: 5rem;
                }
                span{
                    color: #717171; display: flex; align-items: center;
                }
            }
        }
    }

}
</style>